import React from 'react';
import { useTranslation } from 'react-i18next';
import HoverFaqList from './HoverFaqList';

/**
 * FAQ comercial de la home, justo debajo de "Activa ingresos recurrentes".
 *
 * Sin columna de título (a petición del owner): las ocho preguntas van a dos
 * columnas y abren al pasar el ratón. El h2 sigue existiendo pero
 * `visually-hidden`, para que la sección conserve su encabezado de cara a
 * lectores de pantalla y buscadores sin verse en pantalla.
 *
 * El schema FAQPage de estas preguntas lo construye Home.js desde las mismas
 * claves i18n, así que los cambios visuales aquí no lo afectan.
 */
const QUESTION_COUNT = 8;

const HomeSellingFaq = () => {
  const { t } = useTranslation();

  const items = Array.from({ length: QUESTION_COUNT }, (_, i) => {
    const n = i + 1;
    return {
      key: `q${n}`,
      question: t(`home_sell_faq_q${n}`),
      answer: t(`home_sell_faq_a${n}`),
    };
  });

  return (
    <section className="hsf pt-10 pb-100" style={{ background: '#f8f8fc' }}>
      <div className="container">
        <h2 className="visually-hidden">{t('home_sell_faq_title')}</h2>
        <HoverFaqList items={items} columns={2} idPrefix="hsf-sell" />
      </div>
    </section>
  );
};

export default HomeSellingFaq;
